<ng-container>
	<mat-card
		[ngStyle]="_visible()"
		class="patter-table panel"
		style="height: 100%; background: #212121"
	>
		<div
			*ngIf="!locked"
			[ngClass]="{
				'active-panel-tab': _active(),
				'panel-tab': !_active()
			}"
			fxLayout="row"
		>
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button
					(click)="_visibleChange(false)"
					class="close-button"
					color="primary"
					mat-icon-button
					id="mat-clear-button"
				>
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{ title }}</div>
		</div>
		<mat-card-content
			(window:resize)="onResize($event)"
			class="panel-content"
			fxFlex="100"
		>
			<div *ngIf="locked" cdkDragHandle></div>
			<div *ngIf="hasData">
				<div *ngIf="breakpoint === 4">
					<div
						*ngFor="let dataSource of dataSources; let i = index"
						fxFlex="100"
					>
						<div fxLayout="column">
							<div
								*ngFor="
									let line of dataSource.table;
									index as rows
								"
								fxLayout="row"
								fxLayoutAlign="center"
								style="
									border-bottom-style: ridge;
									border-color: #4c4c4c;
									background: #000000;
								"
							>
								<div
									*ngFor="
										let column of line;
										index as columns
									"
									[ngStyle]="tableWidth(columns)"
									style="width: 12.5%; text-wrap: nowrap"
								>
									<div *ngIf="rows === 0" fxFlex="100">
										<!-- <div *ngIf="columns === 0" [ngStyle]="headerTitle()" style="text-align: center;background-color: #000000;color:#99774a;">
											<mat-button-toggle-group (change)="calcChange($event)" [value]="calc">
												<mat-button-toggle value="individual">個々</mat-button-toggle>
												<mat-button-toggle value="average">平均</mat-button-toggle>
											</mat-button-toggle-group>
										</div> -->
										<div
											*ngIf="columns !== 0"
											[ngStyle]="headerCell(columns)"
											style="
												text-align: center;
												background-color: #000000;
												color: #99774a;
											"
										>
											<span style="width: 100%">{{
												column
											}}</span>
										</div>
									</div>
									<div *ngIf="rows !== 0">
										<div
											*ngIf="columns === 0"
											[ngStyle]="
												rowTitle(dataSource, line, rows)
											"
											style="
												text-align: center;
												background-color: #000000;
												color: #99774a;
											"
										>
											<span style="width: 100%">{{
												column
											}}</span>
										</div>
										<div
											*ngIf="columns !== 0"
											[ngStyle]="
												cellStyle(
													dataSource,
													line,
													columns
												)
											"
											style="text-align: center"
										>
											<span
												*ngIf="calc === 'individual'"
												style="width: 11%"
												>{{ column.metrics
												}}{{ unit(rows, line) }}</span
											>
											<span
												*ngIf="calc === 'average'"
												style="width: 11%"
												>{{ column.avarage
												}}{{ unit(rows, line) }}</span
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="breakpoint !== 4">
					<div
						*ngFor="let dataSource of dataSources; let i = index"
						fxFlex="100"
					>
						<div fxLayout="column">
							<div
								*ngFor="
									let line of dataSource.table;
									index as rows
								"
								fxLayout="row"
								fxLayoutAlign="center"
								style="
									border-bottom-style: ridge;
									border-color: #4c4c4c;
									background: #000000;
								"
							>
								<div
									*ngFor="
										let column of line;
										index as columns
									"
									[ngStyle]="tableWidth(columns)"
									style="width: 12.5%; text-wrap: nowrap"
								>
									<div *ngIf="rows === 0" fxFlex="100">
										<div
											*ngIf="columns === 0"
											[ngStyle]="headerTitle()"
											style="
												text-align: center;
												background-color: #000000;
												color: #99774a;
											"
										></div>
										<div
											*ngIf="columns !== 0"
											[ngStyle]="headerCell(columns)"
											style="
												text-align: center;
												background-color: #000000;
												color: #99774a;
											"
										>
											<span style="width: 100%">{{
												column
											}}</span>
										</div>
									</div>
									<div *ngIf="rows !== 0">
										<div
											*ngIf="columns === 0"
											[ngStyle]="
												rowTitle(dataSource, line, rows)
											"
											style="
												text-align: center;
												background-color: #000000;
												color: #99774a;
											"
										>
											<span style="width: 100%">{{
												column
											}}</span>
										</div>
										<div
											*ngIf="columns !== 0"
											[ngStyle]="
												cellStyle(
													dataSource,
													line,
													columns
												)
											"
											style="text-align: center"
										>
											<span
												*ngIf="calc === 'individual'"
												style="width: 11%"
												>{{ column.metrics
												}}{{ unit(rows, line) }}</span
											>
											<span
												*ngIf="calc === 'average'"
												style="width: 11%"
												>{{ column.avarage
												}}{{ unit(rows, line) }}</span
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</ng-container>
